// extracted by mini-css-extract-plugin
module.exports = {"panel":"posts-module--panel--2Z5Uv","keyWords":"posts-module--keyWords--2O1ax"};